export interface WishlistConfig {
  /** URL to redirect unauthenticated users for login */
  loginUrl: string
}

/** Default configuration values */
export const defaultWishlistConfig: WishlistConfig = {
  loginUrl: '/customer/account/login/',
}

/** Cached config instance (singleton pattern) */
let configCache: WishlistConfig | null = null

/** Get wishlist config from window or use defaults (cached) */
export function getWishlistConfig(): WishlistConfig {
  if (configCache) {
    return configCache
  }

  const windowConfig = window.reactConfig?.wishlist

  configCache = {
    ...defaultWishlistConfig,
    ...windowConfig,
  }

  return configCache
}
